import browserUpdate from 'browser-update'

const options = {
  required: { c: -5, f: -5, o: -5, s: -5, e: -5, i: 999 },
  insecure: true,
  unsupported: true,
  mobile: false,
  api: 2019.09,
  reminder: 24,
  reminderClosed: 150,
  shift_page_down: false,
  style: 'top',
  text: `
    Your browser version ({brow_name}) may not support some of the features
    of the <span class="brand brand__logo brand__link">Dev Portal</span>.
    For a better experience, please update or change your browser. We
    recommend up-to-date versions of Chrome or Firefox.
    <a{ignore_but}>Ignore</a>
  `,
  test: false
}

document.addEventListener('DOMContentLoaded', () => {
  browserUpdate(options)
})
